import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css'; 
import rectangleIcon from '../../assets/rectangle_icon.svg'
import klawiaturaImage from '../../assets/klawiatura-cut.png'; 
import grupaMonitorImage from '../../assets/monitor.png';
import { Grid, Box } from '@mui/material';
import NavbarMainPage from '../../components/NavbarMainPage/NavbarMainPage';
import Logo from '../../assets/logo_classic.png';
import FooterLogo from '../../assets/logo_white.png';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import customIcon1 from '../../assets/Icon ion-person.svg'; // Panel hodowcy
import customIcon2 from '../../assets/Icon fa-solid-dove.svg'; // Gołębie
import customIcon3 from '../../assets/rodowod_icon.svg'; // Rodowód
import customIcon4 from '../../assets/Icon fa-solid-network-wired.svg'; // Parowanie
import customIcon5 from '../../assets/Icon fa-solid-paper-plane.svg'; // Loty 
import payRectangle from '../../assets/pay_rectangle.svg';
import mainPigeon from '../../assets/main-pigeon.png';
import mouseImage from '../../assets/mouse.png';

import Switch from '@mui/material/Switch';
import { useSubscription } from '../../contexts/SubscriptionContext';

const Home = () => {
  const navigate = useNavigate();
  const [isYearly, setIsYearly] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('standard');
  const { updatePlan } = useSubscription();
  const testimonials = [
    {
      author: 'Krzysztof Jaśkiewicz',
      role: "Henrick's AVIATORS",
      quote:
        'Lotnik 360 bardzo ułatwia codzienne zarządzanie hodowlą i porządkuje wszystkie dane w jednym miejscu.',
    },
    {
      author: 'Marek Włodarczyk',
      role: 'Hodowla Orlik Team',
      quote:
        'Największy plus to szybkie rodowody i wygodna organizacja par. Wszystko działa prosto i przewidywalnie.',
    },
    {
      author: 'Paweł Kania',
      role: 'SkyLine Pigeons',
      quote:
        'Aplikacja jest czytelna, a planowanie lotów oszczędza czas. To realnie pomaga w prowadzeniu hodowli.',
    },
  ];

  const plans = [
    {
      id: 'basic',
      name: 'Basic',
      monthlyPrice: 19.99,
      yearlyPrice: 197,
      yearlyMonthlyEquivalent: 16.4,
      badge: null,
      packageRef: 'Pakiet Podstawowy',
      includedFeatures: [
        'Panel hodowcy (pełny)',
        'Zarządzanie gołębiami (max 100)',
        'Rodowody 3-4 kolumny + OCR 10 skanów/mies.',
        'Parowanie (max 10 par jednocześnie)',
        'Loty ręczne (max 50 lotów/mies.)',
        'Eksport PDF (podstawowy szablon)',
      ],
      excludedFeatures: [
        'Symulator lotu',
        'Analiza ryzyka',
        'Import z ESK/API',
        'Zaawansowane statystyki',
      ],
    },
    {
      id: 'standard',
      name: 'Standard',
      monthlyPrice: 29.99,
      yearlyPrice: 297,
      yearlyMonthlyEquivalent: 24.75,
      badge: 'Najczęściej wybierany',
      packageRef: 'Pakiet Profesjonalny',
      includedFeatures: [
        'Wszystko z Basic',
        'Nieograniczona liczba gołębi',
        'Rodowody 3-5 kolumn + OCR 100 skanów/mies.',
        'Pełne parowanie (bez limitu par)',
        'Loty: ręczne, PDF, CSV, Excel',
        'Symulator lotu + analiza ryzyka',
        'Zaawansowane statystyki i raporty',
      ],
      excludedFeatures: [
        'Synchronizacja z API federacji',
        'Wsparcie priorytetowe',
      ],
    },
    {
      id: 'premium',
      name: 'Premium',
      monthlyPrice: 49.99,
      yearlyPrice: 479,
      yearlyMonthlyEquivalent: 39.9,
      badge: 'Najlepsza wartość',
      packageRef: 'Pakiet Premium',
      includedFeatures: [
        'Wszystko z Standard',
        'OCR bez limitu',
        'Synchronizacja z API federacji',
        'Auto-import wyników z federacji',
        'Własne szablony rodowodów',
        'Backup w chmurze (automatyczny)',
        'Wsparcie priorytetowe (24h)',
        'Multi-użytkownik (max 3 konta)',
      ],
      excludedFeatures: [],
    },
  ];

  const onPlanSelect = (plan, billingCycle) => {
    // Test mode paywall: emulate active subscription before Stripe integration.
    updatePlan(plan.id);
    console.log('Selected plan:', plan.id, billingCycle);
  };

  const handlePlanClick = (plan) => {
    setSelectedPlan(plan.id);
    onPlanSelect(plan, isYearly ? 'yearly' : 'monthly');
  };

  const iconLabels = [
    'Utwórz swój panel hodowcy',
    'Zarządzaj swoimi gołębiami',
    'Stwórz profesjonalny rodowód',
    'Planuj\nparowanie',
    'Porządkuj loty swoich gołębi'
  ];

  const icons = [customIcon1, customIcon2, customIcon3, customIcon4, customIcon5];

  return (
      <div id="home" className={styles['home']}>
        <div className={styles['background-image']}>       
          <NavbarMainPage />
          <div className={styles['content']}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <div className={`${styles['left-column']} ${styles['reveal-up']}`}> 
                  <h2>Organizuj swoją hodowlę i twórz profesjonalne rodowody.</h2>
                  <h5>
                    Zarządzanie hodowlą nigdy nie było tak <span className={styles['bold-text']}>proste</span>. Paruj swoje gołębie i twórz <span className={styles['bold-text']}>rodowody</span> korzystając z systemu <span className={styles['bold-text']}>wykrywania obrazów.</span> Synchronizuj dane z programu <span className={styles['bold-text']}>Hodowla 2000</span> i <span className={styles['bold-text']}>MojeAsy.</span>
                  </h5>
                  <button 
                    className={styles['create-account-button']}
                    onClick={() => navigate('/pigeons-register')}
                  >
                    Zaczynajmy
                  </button>
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <div className={`${styles['right-column']} ${styles['reveal-up']}`}>
                  <Box sx={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom: '20px'}}>
                      <img className={styles['monitor-asset']} src={grupaMonitorImage} alt="Grupa monitor"/>
                    </Box>

                    <Box sx={{display: 'flex', flexDirection:'row', alignItems:'flex-end', gap: '20px'}}>
                      <img className={styles['keyboard-asset']} src={klawiaturaImage} alt="Klawiatura"/>
                    </Box>
                  </Box>
                </div> 
              </Grid>
            </Grid>
          </div>
        </div>
        <Grid container spacing={2} className={styles['icons-container']}>
          <Grid item xs={12}>
            <div className={styles['background-with-icons']}>
              {icons.map((icon, index) => (
                <div className={`${styles['icon-container']} ${styles['reveal-up']}`} key={index} style={{ animationDelay: `${index * 0.06}s` }}>
                  <div className={styles['icon']}>
                    <img className={styles['custom-icon']} src={icon} alt={`Custom Icon ${index + 1}`} />
                  </div>
                  <p className={styles['icon-label']}>{iconLabels[index]}</p>
                </div>
              ))}
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={`${styles['tutorial-background']} ${styles['reveal-up']}`}>
          <Grid item xs={12} md={6}>
            <div className={styles['text-column']}>
              <p>Masz zapisaną listę gołębi w programie <span className={styles['styled-text-bold-yellow']}>Hodowla 2000?</span></p>
              <p>Kliknij obok, aby obejrzeć poradnik, pokazujący jak przenieść dane do <span className={styles['styled-text-bold-yellow']}>Lotnika 360.</span></p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={styles['video-column']}>
              <iframe width="100%" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </Grid>
        </Grid>

        <Box id="about" className={`${styles['trust-section']} ${styles['reveal-up']}`}>
          <h2 className={styles['trust-section-header']}>Zobacz, co inni sądzą o Lotniku 360</h2>
          <div className={styles['testimonial-grid']}>
            {testimonials.map((item) => (
              <article key={item.author} className={styles['testimonial-tile']}>
                <p className={styles['testimonial-text']}>"{item.quote}"</p>
                <div className={styles['testimonial-meta']}>
                  <div className={styles['testimonial-name']}>{item.author}</div>
                  <div className={styles['testimonial-role']}>{item.role}</div>
                </div>
              </article>
            ))}
          </div>
          <div className={styles['button-container']}>
            <button className={styles['trust-section-button']}>Podziel się swoją opinią</button>
          </div>
        </Box>

        
        <div id="price" className={`${styles['three-columns-section']} ${styles['reveal-up']}`}>
          <div className={styles['header']}>
            <div className={styles['interspace']}> </div>
            <div className={styles['small-gold-text']}> Cennik </div>
            <div className={styles['large-white-text']}> Wybierz pakiet odpowiedni dla twoich potrzeb  </div>
            <div className={styles['header-with-button']}>
              <h3>
                Miesięczny
                <Switch
                  checked={isYearly}
                  onChange={(event) => setIsYearly(event.target.checked)}
                  color="default"
                />
                Roczny
              </h3>
            </div>
            {isYearly && (
              <div className={styles['yearly-benefits']}>
                <span className={styles['yearly-badge']}>2 miesiące gratis</span>
                <span className={styles['yearly-save']}>Oszczędź do 20%</span>
              </div>
            )}
            <div className={styles['trial-note']}>14 dni Premium za darmo dla nowych użytkowników</div>
          </div>

          <div className={styles['three-columns']}>
            {plans.map((plan) => {
              const yearlyRegularPrice = plan.monthlyPrice * 12;
              const isSelected = selectedPlan === plan.id;
              const isPremium = plan.id === 'premium';
              return (
                <Grid item xs={12} md={4} key={plan.id} className={styles['reveal-up']} style={{ animationDelay: `${0.08 + plans.indexOf(plan) * 0.08}s` }}>
                  <div
                    className={`${styles['rounded-rectangle']} ${isPremium ? styles['premium-plan'] : ''} ${isSelected ? styles['selected-plan'] : ''}`}
                  >
                    {plan.badge && <div className={styles['plan-badge']}>{plan.badge}</div>}
                    <div className={styles['rectangle-header']}>{plan.name}</div>
                    <div className={styles['plan-ref']}>{plan.packageRef}</div>
                    {isYearly ? (
                      <>
                        <div className={styles['rectangle-price']}>
                          {plan.yearlyPrice.toFixed(0)} zł
                          <span className={styles['rectangle-value']}> / rok</span>
                        </div>
                        <div className={styles['price-subline']}>
                          ~{plan.yearlyMonthlyEquivalent.toFixed(2)} zł / mies.
                        </div>
                        <div className={styles['crossed-price']}>
                          {yearlyRegularPrice.toFixed(2)} zł / rok
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={styles['rectangle-price']}>
                          {plan.monthlyPrice.toFixed(2)} zł
                          <span className={styles['rectangle-value']}> / mies.</span>
                        </div>
                        <div className={styles['price-subline']}>Rozliczane miesięcznie</div>
                      </>
                    )}
                    <div className={styles['underline-container']}>
                      <div className={styles['underline']}></div>
                    </div>
                    <ul className={styles['feature-list']}>
                      {plan.includedFeatures.map((feature) => (
                        <li key={feature} className={styles['feature-item-included']}>✅ {feature}</li>
                      ))}
                      {plan.excludedFeatures.map((feature) => (
                        <li key={feature} className={styles['feature-item-excluded']}>❌ {feature}</li>
                      ))}
                    </ul>
                    <button
                      type="button"
                      className={styles['plan-cta']}
                      onClick={() => handlePlanClick(plan)}
                    >
                      Wybierz plan
                    </button>
                  </div>
                </Grid>
              );
            })}
          </div>
          </div>

          <div id="contact" className={`${styles['contact-section']} ${styles['reveal-up']}`}>
            <h2 className={styles['contact-header']}>Kontakt</h2>
            <div className={styles['contact-content']}>
              <div className={styles['contact-form']}> 
                <span className={styles['contact-blue-text-huge']}> Masz pytania <br></br> albo potrzebujesz pomocy, <br></br></span> 
                <span className={styles['contact-green-text-huge']}> skontaktuj się z nami </span>

                <span className={styles['interspace-white']}></span>
                <div className={styles['form-row']}>
                  <div className={styles['form-column']}>
                    <label for="name">Imię</label>
                    <input type="text" placeholder="Napisz swoje imię" className={styles['form-input']} />
                  </div>
                  <div className={styles['form-column']}>
                    <label for="email"> Adres email</label>
                    <input type="email" placeholder="Wprowadź swój Email" className={styles['form-input']} />
                  </div>
                </div>

                <div className={styles['form-column']}>
                  <label for="Twoja wiadomość"> Napisz w czym możemy Ci pomóc</label>
                  <textarea placeholder="Napisz wiadomość" className={styles['form-textarea']}></textarea>
                  <div className={styles['button-container']}>
                    <button className={styles['submit-button']}>Wyślij</button>
                  </div>
                </div>
              </div>
              <img className={styles['contact-image']} src={mainPigeon} alt="Main pigeon"/>
            </div>
          </div>

          {/* Footer */}
          <footer className={styles['footer']}>
            <div className={styles['footer-content']}>
              <Grid container spacing={4}>
                {/* Logo i opis */}
                <Grid item xs={12} md={4}>
                  <div className={styles['footer-logo-section']}>
                    <img src={FooterLogo} alt="Logo" className={styles['footer-logo']} />
                    <p className={styles['footer-description']}>
                      Profesjonalne narzędzie do zarządzania hodowlą gołębi. 
                      Twórz rodowody, paruj gołębie i śledź postępy swojej hodowli.
                    </p>
                  </div>
                </Grid>

                {/* Linki nawigacyjne */}
                <Grid item xs={12} sm={6} md={2}>
                  <div className={styles['footer-section']}>
                    <h4 className={styles['footer-heading']}>Nawigacja</h4>
                    <ul className={styles['footer-links']}>
                      <li><a href="#home">Strona główna</a></li>
                      <li><a href="#about">O nas</a></li>
                      <li><a href="#price">Cennik</a></li>
                      <li><a href="#contact">Kontakt</a></li>
                    </ul>
                  </div>
                </Grid>

                {/* Informacje prawne */}
                <Grid item xs={12} sm={6} md={2}>
                  <div className={styles['footer-section']}>
                    <h4 className={styles['footer-heading']}>Informacje</h4>
                    <ul className={styles['footer-links']}>
                      <li><a href="#privacy">Polityka prywatności</a></li>
                      <li><a href="#terms">Regulamin</a></li>
                      <li><a href="#faq">FAQ</a></li>
                      <li><a href="#support">Wsparcie</a></li>
                    </ul>
                  </div>
                </Grid>

                {/* Kontakt */}
                <Grid item xs={12} sm={6} md={4}>
                  <div className={styles['footer-section']}>
                    <h4 className={styles['footer-heading']}>Kontakt</h4>
                    <ul className={styles['footer-contact']}>
                      <li>
                        <MailOutlineIcon className={styles['footer-icon']} />
                        <span>kontakt@lotnik360.pl</span>
                      </li>
                      <li>
                        <LocalPhoneOutlinedIcon className={styles['footer-icon']} />
                        <span>+48 600 500 400</span>
                      </li>
                    </ul>
                  </div>
                </Grid>
              </Grid>

              {/* Copyright */}
              <div className={styles['footer-bottom']}>
                <p className={styles['footer-copyright']}>
                  © {new Date().getFullYear()} Lotnik 360. Wszelkie prawa zastrzeżone.
                </p>
              </div>
            </div>
          </footer>
      </div>
  );
}

export default Home;
